export enum PhoneNumberType {
    Office = 'Office',
    Mobile = 'Mobile',
}